import { useState } from "react";
import "../../../assets/css/customer/category/CategoryShowcase.css";
import BedRoom from "../../../assets/images/bed_icon.png";
import Kitchen from "../../../assets/images/kitchen_icon.png";
import Office from "../../../assets/images/office_icon.png";
import Sofa from "../../../assets/images/sofa_icon.png";
import { useNavigate } from "react-router-dom";

const CategoryShowcase = () => {
  const navigate = useNavigate();
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [showMoreHovered, setShowMoreHovered] = useState(false);

  const categories = [
    {
      id: 1,
      name: "Bedroom",
      icon: BedRoom,
      title: "BEDROOM COLLECTION",
      description: "Discover our exclusive bedroom furniture",
      image:
        "https://i.pinimg.com/originals/28/07/e8/2807e80d563b550cc00f35d02864e1b6.webp",
    },
    {
      id: 2,
      name: "Living room",
      icon: Sofa,
      title: "FURNISHING AND COMPLEMENTS",
      description: "Discover the design table collection",
      image:
        "https://cdn.pixabay.com/photo/2023/04/19/12/16/interior-design-7937589_1280.jpg",
    },
    {
      id: 3,
      name: "Office",
      icon: Office,
      title: "OFFICE FURNITURE",
      description: "Modern workspace solutions",
      image:
        "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=1200&fit=crop",
    },
    {
      id: 4,
      name: "Kitchen",
      icon: Kitchen,
      title: "BATHROOM ESSENTIALS",
      description: "Elegant bathroom furniture & accessories",
      image:
        "https://i.pinimg.com/originals/b2/86/27/b2862784493a4984cadb3d0fae9af830.jpg",
    },
  ];

  return (
    <section className="category-showcase">
      <div className="categories-showcase-wrapper">
        {categories.map((category) => (
          <div
            key={category.id}
            className={`category-showcase-panel ${
              hoveredCategory === category.id
                ? "expanded"
                : hoveredCategory
                  ? "squeezed"
                  : ""
            }`}
            onMouseEnter={() => setHoveredCategory(category.id)}
            onMouseLeave={() => setHoveredCategory(null)}
            style={{ backgroundImage: `url(${category.image})` }}
          >
            <div className="category-showcase-overlay"></div>

            <div className="category-showcase-content">
              <div className="category-showcase-icon-wrapper">
                <div className="category-showcase-icon">
                  <img src={category.icon} alt="Bedroom" />
                </div>
              </div>
              <h3 className="category-showcase-name">{category.name}</h3>
            </div>

            <div
              className={`category-showcase-info ${
                hoveredCategory === category.id ? "visible" : ""
              }`}
            >
              <h2 className="category-showcase-title">{category.title}</h2>
              <p className="category-showcase-description">
                {category.description}
              </p>
            </div>
          </div>
        ))}

        <div
          className={`category-show-more-panel ${
            hoveredCategory ? "squeezed" : ""
          } ${showMoreHovered ? "expanded" : ""}`}
          onMouseEnter={() => {
            setShowMoreHovered(true);
            setHoveredCategory(null);
          }}
          onMouseLeave={() => setShowMoreHovered(false)}
        >
          <div className="category-show-more-content">
            {!showMoreHovered ? (
              <div className="plus-icon">+</div>
            ) : (
              <div className="show-more-text">
                <span
                  onClick={() => {
                    navigate("/products");
                  }}
                >
                  Show more
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CategoryShowcase;
